export const DIRECT_DEPOSIT = 1;
export const DRAGON_PAY = 2;
export const QUICK_WIRE = 3;